import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/components/LanguageDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/components/layout/front/FrontMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/components/layout/front/HeaderAuthWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/components/layout/front/UserDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/components/layout/ModeDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","displayName","Image","Fallback"] */ "/vercel/path1/node_modules/.pnpm/@radix-ui+react-avatar@1.1.3_@types+react-dom@18.3.1_@types+react@18.3.12_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/.pnpm/next@15.1.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/packages/i18n/src/Trans.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/packages/ui/src/blocks/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/packages/ui/src/layouts/components/front/Header.tsx");
